<template>
  <div>
    <div class="form-section">
      <h4 class="member-details-form-section-header">Privacy and access</h4>
      <caption class="required-field-indicator">* Indicates required field</caption>

      <Alert
        message="Privacy is only maintained when it is enabled. When disabled, all information, current and historic, will be visible to other members on the policy."
        alertType="info"
        v-if="loggedInUserAccessingThemselves"
      />

      <FormField id="privacy" v-if="loggedInUserAccessingThemselves" labelText="Keep my information private" :helperText="refData.keepPrivateHelpText.informationText">
        <ul class="radio-group large">
          <li v-for="option in privateOptions" :key="`privacy-${option.returnValue}`">
            <input v-model="v$.memberDetails.privacyAccess.keepPrivate.$model" type="radio" :id="`privacy-${option.returnValue}`" :value="option.returnValue" name="privacy" />
            <label :for="`privacy-${option.returnValue}`">{{ option.display }}</label>
          </li>
        </ul>
      </FormField>
      <FormField
        id="policyPermission"
        labelText="Policy permission"
        :helperText="refData.policyPermissionHelpText.informationText"
        :additionalLabel="refData.policyPermissionInformationText.informationText"
      >
        <ul class="radio-group large">
          <li v-for="option in policyPermissionOptions" :key="`access-${option.returnValue}`">
            <input
              :disabled="shouldPermissionBeDisabled()"
              v-model.lazy="v$.memberDetails.privacyAccess.policyPermission.$model"
              type="radio"
              :id="`access-${option.returnValue}`"
              :value="option.returnValue"
              name="policyPermission"
            />
            <label :for="`access-${option.returnValue}`">{{ option.display }}</label>
          </li>
        </ul>
      </FormField>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { UpdateMemberDetailsStepNames } from '@/enums';

import MemberDetailsMixin from './MemberDetailsMixin';

export default {
  setup() { return { v$: useVuelidate() }; },

  name: UpdateMemberDetailsStepNames.step3,
  mixins: [MemberDetailsMixin],
  props: {
    initialData: {
      type: Object,
    },
  },
  data() {
    return {
      privateOptions: [
        { display: 'Yes', returnValue: true },
        { display: 'No', returnValue: false },
      ],
    };
  },
  computed: {
    policyPermissionOptions() {
      if (this.refData) {
        return this.refData.policyPermissionOptions;
      }
      return [];
    },
  },
  validations: {
    memberDetails: {
      privacyAccess: {
        keepPrivate: {
          required,
        },
        policyPermission: {
          required,
        },
      },
    },
  },
  methods: {
    shouldPermissionBeDisabled() {
      // If the member is accessing themselves, they cannot update their own policy permissions
      if (this.loggedInUserAccessingThemselves) {
        return true;
      }

      /**
       * Get the access role of the member who is being accessed from the initial data, as the initial data is what
       * matters, and not what has been updated otherwise a defect will appear where someone who has updated another's
       * policy permission and will not be able to change it back.
       */
      let memberDetailsAccessRole = this.initialData?.privacyAccess?.policyPermission;
      if (memberDetailsAccessRole === undefined) {
        return true;
      }

      memberDetailsAccessRole = memberDetailsAccessRole.toLowerCase();

      // Get the access levels for the current membership id
      if (this.currentMemberDetail && this.currentMemberDetail.memberships) {
        switch (this.currentMembership.accessLevel.toLowerCase()) {
          case this.AccessLevel.POLICY_HOLDER_ACCESS:
            if (memberDetailsAccessRole === this.AccessLevel.LIMITED_ACCESS || memberDetailsAccessRole === this.AccessLevel.NO_ACCESS) {
              return true;
            }
            return false;
          case this.AccessLevel.FULL_ACCESS:
            // If the full access is accessing someone who is accessing self access can edit
            if (memberDetailsAccessRole === this.AccessLevel.SELF_ACCESS) {
              return false;
            }
            return true;
          default:
            return true;
        }
      }

      // Default to disable
      return true;
    },
  },
};
</script>
